import React, { forwardRef } from 'react';
import { Avatar, IconButton, Menu, MenuItem } from '@material-ui/core';
import { MoreVert as MoreIcon } from '@material-ui/icons';
import styles from './index.module.scss';

const AppHeader = forwardRef((props: any, ref: any) => {
    const { title, subtitle, avatarText, menuItems, theme } = props;
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

    const onOpenMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const onCloseMenu = () => {
        setAnchorEl(null);
    }

    return (
        <div className={styles.container + `${theme ? ' ' + theme : ''}`} ref={ref}>
            <div className={styles.header}>
                <Avatar className={styles.avatar}>{avatarText}</Avatar>
                <div className={styles.content}>
                    <div className={styles.title}>{title}</div>
                    <div className={styles.subtitle}>{subtitle}</div>
                </div>
            </div>
            {menuItems ? <div className={styles.actions}>
                <IconButton aria-label="more" className={styles.moreButton} onClick={onOpenMenu}>
                    <MoreIcon />
                </IconButton>
                <Menu anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={onCloseMenu}>
                    {menuItems.map((item: any, i: number) => <MenuItem key={i}>{item.label}</MenuItem>)}
                </Menu>
            </div> : null}
        </div>
    );
});

export default AppHeader;